import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCta from "./StickyMobileCta";
import BackToTop from "./BackToTop";
import FloatingDesktopCta from "./FloatingDesktopCta";
import { createContext, useContext, useState, useEffect, lazy, Suspense } from "react";

// Lazy-load SearchDialog to avoid pulling in faqData (960KB) on initial page load
const SearchDialog = lazy(() => import("./SearchDialog"));

// Global search context so Header can trigger the dialog
interface SearchContextType {
  openSearch: () => void;
}
const SearchContext = createContext<SearchContextType>({ openSearch: () => {} });
export const useSearch = () => useContext(SearchContext);

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [open, setOpen] = useState(false);

  // Global Cmd+K / Ctrl+K shortcut to open search
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setOpen(prev => !prev);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <SearchContext.Provider value={{ openSearch: () => setOpen(true) }}>
      <div className="min-h-screen flex flex-col">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:bg-navy focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2"
        >
          Hoppa till huvudinnehåll
        </a>
        <Header />
        <main id="main-content" className="flex-1 pb-16 lg:pb-0">{children}</main>
        <Footer />
        <StickyMobileCta />
        <BackToTop />
        <FloatingDesktopCta />
        {/* <ExitIntentPopup /> — PAUSAD */}
        {open && (
          <Suspense fallback={null}>
            <SearchDialog open={open} onOpenChange={setOpen} />
          </Suspense>
        )}
      </div>
    </SearchContext.Provider>
  );
}
